import { Button } from "@workspace/ui/components/button"
import { MeridialLogo } from "@/components/shared/meridial-logo"
import { HugeiconsIcon } from "@hugeicons/react"
import {
  ArrowUpRight01Icon,
  MultiplicationSignIcon,
} from "@hugeicons/core-free-icons"
import { CallSwipe } from "@/components/voicebox/call-swipe"
import { useMeridialStore } from "@/store"
import { cn } from "@workspace/ui/lib/utils"
import { WIDGET_HEIGHT, WIDGET_WIDTH } from "@/lib/constants"

interface HomeProps {
  handleStartSession: (question?: string) => void
  onClose: () => void
  selectedQuestion?: string
  onSelectQuestion: (question?: string) => void
}

export function Home({
  handleStartSession,
  onClose,
  selectedQuestion,
  onSelectQuestion,
}: HomeProps) {
  const props = useMeridialStore((s) => s.props)

  return (
    <div
      className="flex flex-col p-4 gap-4"
      style={{ height: WIDGET_HEIGHT, width: WIDGET_WIDTH }}
    >
      <header className="flex shrink-0 items-center justify-between">
        <MeridialLogo className="w-10 h-10 handle cursor-grab" />
        <Button
          size="icon-lg"
          variant="destructive"
          className="rounded-full"
          onClick={onClose}
        >
          <HugeiconsIcon icon={MultiplicationSignIcon} />
        </Button>
      </header>
      <section className="flex min-h-0 flex-1 flex-col justify-center gap-4 overflow-y-auto">
        <div className="space-y-2">
          <h1 className="text-4xl font-bold">Hi there!</h1>
          <p className="text-2xl font-medium">How can i help you today?</p>
        </div>
        <div className="space-y-2">
          {props?.sampleQuestions?.map((question, index) => (
            <div
              key={index}
              className={cn(
                "border rounded-lg px-4 py-2 flex items-center justify-between group cursor-pointer",
                selectedQuestion === question
                  ? "bg-primary/10 dark:bg-primary/10 border-primary hover:bg-primary/15 dark:hover:bg-primary/20"
                  : "bg-card hover:bg-accent"
              )}
              onClick={() => onSelectQuestion(question)}
            >
              <p className="w-full truncate">{question}</p>
              <HugeiconsIcon
                icon={ArrowUpRight01Icon}
                className="opacity-0 group-hover:opacity-100 transition-opacity"
              />
            </div>
          ))}
        </div>
      </section>
      <footer className="flex shrink-0 flex-col gap-4 items-center pt-4 cancel-drag">
        <CallSwipe
          className="w-full"
          onCall={() => handleStartSession(selectedQuestion)}
        />
        <_PoweredBy />
      </footer>
    </div>
  )
}

function _PoweredBy() {
  return (
    <div className="flex items-center space-x-2">
      <p className="text-xs font-medium text-muted-foreground flex items-center">
        Powered by
        <a
          href="https://meridial.dev"
          target="_blank"
          rel="noreferrer"
          className="flex items-center group cursor-pointer ml-1"
        >
          Meridial
          <HugeiconsIcon
            icon={ArrowUpRight01Icon}
            className="size-4 opacity-0 group-hover:opacity-100 transition-opacity"
          />
        </a>
      </p>
    </div>
  )
}
